// src/features/files/components/FileSourceButtons.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button } from '@mui/material';
import {
  CloudUpload as CloudUploadIcon,
  FolderOpen as FolderOpenIcon,
} from '@mui/icons-material';

/**
 * The two ways of adding files, looking the same wherever files are added:
 * pick a file already in Filer (outlined), or upload from the computer (the main
 * action, filled, rightmost). Leave out `onChoose` or `onUpload` to hide that button.
 * `size="medium"` matches other main actions in a card header.
 */
export default function FileSourceButtons({
  onChoose,
  onUpload,
  chooseLabel,
  uploadLabel,
  disabled = false,
  size = 'small',
  sx,
}) {
  const { t } = useTranslation(['files']);
  if (!onChoose && !onUpload) return null;
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexShrink: 0, ...sx }}>
      {onChoose && (
        <Button size={size} variant="outlined" startIcon={<FolderOpenIcon />} onClick={onChoose} disabled={disabled}>
          {chooseLabel || t('files:actions.choose_from_files')}
        </Button>
      )}
      {onUpload && (
        <Button size={size} variant="contained" startIcon={<CloudUploadIcon />} onClick={onUpload} disabled={disabled}>
          {uploadLabel || t('files:upload.button')}
        </Button>
      )}
    </Box>
  );
}
